<form (ngSubmit)="create()" [formGroup]="createForm" class="drop-padding mainForm">
  <mat-form-field appearance="outline">
    <mat-label>Название</mat-label>
    <input matInput type="text" formControlName="description" placeholder="Название" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Начало производства</mat-label>
    <input matInput [matDatepicker]="picker_from" formControlName="date_from" />
    <mat-datepicker-toggle matSuffix [for]="picker_from"></mat-datepicker-toggle>
    <mat-datepicker #picker_from></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Конец производства</mat-label>
    <input matInput [matDatepicker]="picker_to" formControlName="date_to" />
    <mat-datepicker-toggle matSuffix [for]="picker_to"></mat-datepicker-toggle>
    <mat-datepicker #picker_to></mat-datepicker>
  </mat-form-field>
  <app-engine-select [control]="enginesControl"></app-engine-select>
  <button mat-flat-button color="primary">Сохранить</button>
</form>
